import {
  Box,
  chakra,
  Heading,
  Text,
  Center,
  useColorModeValue,
  HStack,
  Image,
  Button,
  Link,
  SimpleGrid,
  Stack,
  Avatar,
} from '@chakra-ui/react';

import { BsArrowUpRight} from 'react-icons/bs';
import Github_icon from "../assets/github.png";
import Yoox_logo from "../assets/yoox_logo.png";
import Headphone_zone_logo from "../assets/headphone-zone.png";
import Asos_logo from "../assets/assos-logo.png";
import buylance from "../assets/BUYLANCE-logo.png";


export default function Projects() {
  return (
    <Box id='projects'>
    <Box  mt={'100px'} mb={'100px'}>
        <chakra.h1
            textAlign={'center'}
            fontSize={{base:"2xl",lg:"4xl"}}
            fontWeight={'bold'}
            bg={'teal'}
            color={'white'}
            w={'40%'}
            h='50px'
            rounded="2xl"
            m={'auto'}
            mb={'50px'}
          >
          Projects
        </chakra.h1>
    <Center >
    <SimpleGrid spacing={10} columns={{base:1,md:2}} rounded={'20%'}>

  
      <Box
        maxW={'445px'}
        w={'full'}
        bg={useColorModeValue('white', 'gray.900')}
        boxShadow={useColorModeValue('6px 6px 0 teal', '6px 6px 0 cyan')}
        rounded={'md'}
        border={"1px solid teal"}
        p={6}
        overflow={'hidden'}>
        <Box
          h={'210px'}
          bg={'gray.100'}
          mt={-6}
          mx={-6}
          mb={6}
          pos={'relative'}>
          <Image
            src={Yoox_logo}
            layout={'fill'}
          />
        </Box>
        <Stack>
        <Link href='https://e-commerce-yoox-com.vercel.app/' target={"_blank"}>
          <Text
            color={'teal.500'}
            textTransform={'uppercase'}
            fontWeight={800}
            fontSize={'sm'}
            letterSpacing={1.1}>
           YOOX.COM
          </Text>
        </Link>
          <Heading
            color={useColorModeValue('gray.700', 'white')}
            fontSize={'2xl'}
            fontFamily={'body'}>
           An e-commerce website
          </Heading>
          <Text color={'gray.500'}>
          An Individual project clone of YOOX.COM based on fashion and lifestyle products,
          where user can buy clothing, footwear, and other quality products.
          </Text>
        </Stack>
        <Heading
            color={useColorModeValue('gray.700', 'white')}
            fontSize={'lg'}
            fontFamily={'body'}>
           Tech Stack
          </Heading>
          <Center>
          <HStack p={2}>
            <Image src='https://img.shields.io/badge/react-%2320232a.svg?style=for-the-badge&logo=react&logoColor=%2361DAFB' alt='react_icon'/>
            <Image src='https://img.shields.io/badge/chakra-%234ED1C5.svg?style=for-the-badge&logo=chakraui&logoColor=white' alt='chakra_icon'/>
          </HStack>
          </Center>
          <Center borderTop="2px solid">
            <Stack mt={6} direction={'row'} spacing={4} align={'center'} >
            <Link href='https://github.com/avinash7488/e-commerce-yoox.com' target={"_blank"}>
              <Avatar
              src={Github_icon}
              alt={'Author'}
              />
            </Link>
              <Button bg={'teal'} color={'white'}>
                <Link href='https://e-commerce-yoox-com.vercel.app/' target={"_blank"}> 
                <Text fontSize={'md'} fontWeight={'bold'} textAlign="center" w={100}>
                    View 
                </Text>
                </Link>
                <BsArrowUpRight fontWeight={'bold'}/>
            </Button>
            </Stack>
          </Center>
        
      </Box>
   

  
      <Box
        maxW={'445px'}
        w={'full'}
        bg={useColorModeValue('white', 'gray.900')}
        boxShadow={useColorModeValue('6px 6px 0 teal', '6px 6px 0 cyan')}
        rounded={'md'}
        border={"1px solid teal"}
        p={6}
        overflow={'hidden'}>
        <Box
          h={'210px'}
          bg={'gray.100'}
          mt={-6}
          mx={-6}
          mb={6}
          pos={'relative'}>
          <Image
            src={buylance}
            layout={'fill'}
          />
        </Box>
        <Stack>
        <Link href='https://buylance-ecomm.vercel.app/' target={"_blank"}> 
          <Text
            color={'teal.500'}
            textTransform={'uppercase'}
            fontWeight={800}
            fontSize={'sm'}
            letterSpacing={1.1}>
            BUYLANCE.COM
          </Text>
        </Link>
          <Heading
            color={useColorModeValue('gray.700', 'white')}
            fontSize={'2xl'}
            fontFamily={'body'}>
           An e-commerce website
          </Heading>
          <Text color={'gray.500'}>
          A Group project based on fashion and lifestyle products,
          where user can buy clothing, footwear, and other quality products.
          </Text>
        </Stack>
        <Heading
            color={useColorModeValue('gray.700', 'white')}
            fontSize={'lg'}
            fontFamily={'body'}>
           Tech Stack
          </Heading>
          <Center>
          <HStack p={2} wrap={"wrap"}>
            <Image m={1} src='https://img.shields.io/badge/javascript-%23323330.svg?style=for-the-badge&logo=javascript&logoColor=%23F7DF1E' alt='JavaScript_icon'/>
            <Image m={1} src='https://img.shields.io/badge/react-%2320232a.svg?style=for-the-badge&logo=react&logoColor=%2361DAFB' alt='react_icon'/>
            <Image m={1} src='https://img.shields.io/badge/redux-%23323330.svg?style=for-the-badge&logo=redux&logoColor=%23F7DF1E' alt='redux_icon'/>
            <Image m={1} src='https://img.shields.io/badge/typescript-%23007ACC.svg?style=for-the-badge&logo=typescript&logoColor=white' alt='typescript_icon'/>
            <Image m={1} src='https://img.shields.io/badge/css3-%231572B6.svg?style=for-the-badge&logo=css3&logoColor=white' alt='CSS_icon'/>
            <Image m={1} src='https://img.shields.io/badge/chakra-%234ED1C5.svg?style=for-the-badge&logo=chakraui&logoColor=white' alt='chakra_icon'/>
          </HStack>
          </Center>
          <Center borderTop="2px solid">
            <Stack mt={6} direction={'row'} spacing={4} align={'center'} >
            <Link href='https://github.com/avinash7488/Buylance.com' target={"_blank"}>
              <Avatar
              src={Github_icon}
              alt={'Author'}
              />
            </Link>
              <Button bg={'teal'} color={'white'}>
                <Link href='https://buylance-ecomm.vercel.app/' target={"_blank"}> 
                <Text fontSize={'md'} fontWeight={'bold'} textAlign="center" w={100}>
                    View 
                </Text>
                </Link>
                <BsArrowUpRight fontWeight={'bold'}/>
            </Button>
            </Stack>
          </Center>
        
      </Box>

       
      <Box
        maxW={'445px'}
        w={'full'}
        bg={useColorModeValue('white', 'gray.900')}
        boxShadow={useColorModeValue('6px 6px 0 teal', '6px 6px 0 cyan')}
        rounded={'md'}
        border={"1px solid teal"}
        p={6}
        overflow={'hidden'}>
        <Box
          h={'210px'}
          bg={'gray.100'}
          mt={-6}
          mx={-6}
          mb={6}
          pos={'relative'}>
          <Image
            src={Headphone_zone_logo}
            layout={'fill'}
          />
        </Box>
        <Stack>
        <Link href='https://headphone-zone-4224.netlify.app/' target={"_blank"}>
          <Text
            color={'teal.500'}
            textTransform={'uppercase'}
            fontWeight={800}
            fontSize={'sm'}
            letterSpacing={1.1}>
            HEADPHONE ZONE
          </Text>
        </Link>
          <Heading
            color={useColorModeValue('gray.700', 'white')}
            fontSize={'2xl'}
            fontFamily={'body'}>
           An e-commerce website
          </Heading>
          <Text color={'gray.500'}>
          A collaborative project based on Electronic Devices.
           where user can buy earphones, headphones, speakers, etc.
          </Text>
        </Stack>
        <Heading
            color={useColorModeValue('gray.700', 'white')}
            fontSize={'lg'}
            fontFamily={'body'}>
           Tech Stack
          </Heading>
          <Center>
          <HStack p={2} wrap={"wrap"}>
            <Image src='https://img.shields.io/badge/html5-%23E34F26.svg?style=for-the-badge&logo=html5&logoColor=white' alt='HTML_icon'/>
            <Image m={1} src='https://img.shields.io/badge/css3-%231572B6.svg?style=for-the-badge&logo=css3&logoColor=white' alt='CSS_icon'/>
            <Image m={1} src='https://img.shields.io/badge/javascript-%23323330.svg?style=for-the-badge&logo=javascript&logoColor=%23F7DF1E' alt='JavaScript_icon'/>
          </HStack>
          </Center>
          <Center borderTop="2px solid">
            <Stack mt={6} direction={'row'} spacing={4} align={'center'} >
            <Link href='https://github.com/avinash7488/foolish-quiet-4224' target={"_blank"}>
              <Avatar
              src={Github_icon}
              alt={'Author'}
              />
            </Link>
              <Button bg={'teal'} color={'white'}>
                <Link href='https://headphone-zone-4224.netlify.app/' target={"_blank"}> 
                <Text fontSize={'md'} fontWeight={'bold'} textAlign="center" w={100}>
                    View 
                </Text>
                </Link>
                <BsArrowUpRight fontWeight={'bold'}/>
            </Button>
            </Stack>
          </Center>
        
      </Box>

      <Box
        maxW={'445px'}
        w={'full'}
        bg={useColorModeValue('white', 'gray.900')}
        boxShadow={useColorModeValue('6px 6px 0 teal', '6px 6px 0 cyan')}
        rounded={'md'}
        border={"1px solid teal"}
        p={6}
        overflow={'hidden'}>
        <Box
          h={'210px'}
          bg={'gray.100'}
          mt={-6}
          mx={-6}
          mb={6}
          pos={'relative'}>
          <Image
            src={Asos_logo}
            layout={'fill'}
          />
        </Box>
        <Stack>
        <Link href='https://assos-ecom.netlify.app/' target={"_blank"}>
          <Text
            color={'teal.500'}
            textTransform={'uppercase'}
            fontWeight={800}
            fontSize={'sm'}
            letterSpacing={1.1}>
            ASSOS DESIGN
          </Text>
          </Link>
          <Heading
            color={useColorModeValue('gray.700', 'white')}
            fontSize={'2xl'}
            fontFamily={'body'}>
           An e-commerce website
          </Heading>
          <Text color={'gray.500'}>
          A Group project based on fashion and lifestyle products,
          where user can buy clothing, footwear, and other quality products.
          </Text>
        </Stack>
        <Heading
            color={useColorModeValue('gray.700', 'white')}
            fontSize={'lg'}
            fontFamily={'body'}>
           Tech Stack
          </Heading>
          <Center>
          <HStack p={2} wrap={"wrap"}>
            <Image src='https://img.shields.io/badge/html5-%23E34F26.svg?style=for-the-badge&logo=html5&logoColor=white' alt='HTML_icon'/>
            <Image m={1} src='https://img.shields.io/badge/css3-%231572B6.svg?style=for-the-badge&logo=css3&logoColor=white' alt='CSS_icon'/>
            <Image m={1} src='https://img.shields.io/badge/javascript-%23323330.svg?style=for-the-badge&logo=javascript&logoColor=%23F7DF1E' alt='JavaScript_icon'/>
          </HStack>
          </Center>
          <Center borderTop="2px solid">
            <Stack mt={6} direction={'row'} spacing={4} align={'center'} >
            <Link href='https://github.com/arsalanshaikhh/asos.com-clone-Unit2' target={"_blank"}>
              <Avatar
              src={Github_icon}
              alt={'Author'}
              />
            </Link>
              <Button bg={'teal'} color={'white'}>
                <Link href='https://assos-ecom.netlify.app/' target={"_blank"}> 
                <Text fontSize={'md'} fontWeight={'bold'} textAlign="center" w={100}>
                    View 
                </Text>
                </Link>
                <BsArrowUpRight fontWeight={'bold'}/>
            </Button>
            </Stack>
          </Center>
        
      </Box>
      </SimpleGrid>
      
  
    </Center>

    {/* <!-- <div style={{display:"flex"}}>
  
![JavaScript](https://img.shields.io/badge/javascript-%23323330.svg?style=for-the-badge&logo=javascript&logoColor=%23F7DF1E)
![HTML5](https://img.shields.io/badge/html5-%23E34F26.svg?style=for-the-badge&logo=html5&logoColor=white) 
![CSS3](https://img.shields.io/badge/css3-%231572B6.svg?style=for-the-badge&logo=css3&logoColor=white) 
![Chakra](https://img.shields.io/badge/chakra-%234ED1C5.svg?style=for-the-badge&logo=chakraui&logoColor=white) 
![Next JS](https://img.shields.io/badge/Next-black?style=for-the-badge&logo=next.js&logoColor=white) 
![React](https://img.shields.io/badge/react-%2320232a.svg?style=for-the-badge&logo=react&logoColor=%2361DAFB) 
![TypeScript](https://img.shields.io/badge/typescript-%23007ACC.svg?style=for-the-badge&logo=typescript&logoColor=white) 
![MongoDB](https://img.shields.io/badge/MongoDB-%2338B2AC.svg?style=for-the-badge&logo=MongoDB&logoColor=white) 
![Node JS](https://img.shields.io/badge/Node-%23E34F26.svg?style=for-the-badge&logo=node.js&logoColor=white) 
<br/>![Netlify](https://img.shields.io/badge/netlify-%23000000.svg?style=for-the-badge&logo=netlify&logoColor=#00C7B7) 
![Vercel](https://img.shields.io/badge/vercel-%231572B6.svg?style=for-the-badge&logo=vercel&logoColor=white) 
![Vs-Code](https://img.shields.io/badge/vscode-%23E34F26.svg?style=for-the-badge&logo=visualstudio&logoColor=white)
  </div> --> */}
    </Box>
    </Box>
  );
}